// css
import './assets/global.scss'


// fontawesome
import { library } from "@fortawesome/fontawesome-svg-core"
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { dom } from "@fortawesome/fontawesome-svg-core"

library.add(fas);
library.add(far);
dom.watch();


// vue libs
import { createPinia } from 'pinia'
import { createApp } from 'vue'
import Oruga from '@oruga-ui/oruga-next'


// local app
import App from './App.vue'
import router from './router'

const app = createApp(App)
const pinia = createPinia()


app.use(router)
    .use(pinia)
    .use(Oruga)
    .mount('#app')
